import Api from '../index';
import {endpoints} from '../endpoints';

export default class Master extends Api{
    getMasters(data){        
        let url = this.buildUrl(endpoints.ob.masters, 'full');        
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response);
    }   
}